import { useEffect, useState } from 'react';

const MOBILE_MAX_WIDTH = 480;

const useWindowSize = (): {
    isMobileDevice: boolean;
} => {
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);
    useEffect(() => {
        const updateInnerWidth = (): void => {
            setInnerWidth(window.innerWidth);
        };
        window.addEventListener('resize', updateInnerWidth);
        return () => {
            window.removeEventListener('resize', updateInnerWidth);
        };
    }, []);
    return {
        isMobileDevice: innerWidth <= MOBILE_MAX_WIDTH
    };
};

export default useWindowSize;
